import SEOPage from "./SEOPage";

export default function MaleInfertilityTreatmentAmbala() {
  return (
    <SEOPage
      title="Male Infertility Treatment in Ambala"
      description="Advanced Male Infertility Treatment in Ambala including semen analysis, fertility assessment, ICSI and reproductive medicine."
      canonical="https://amaanativf.com/male-infertility-treatment-in-ambala"
      heading="Male Infertility Treatment in Ambala"
      focusKeyword="Male Infertility Treatment in Ambala"
    />
  );
}